import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { NotificationService } from './../../services/notification.service';
import { Component, Inject, Input, OnChanges, OnInit } from '@angular/core';
import { APP_CONFIG } from '../../app.config';
import { IAppConfig } from '../../app.config.shared';
import { ActivatedRoute, Router } from '@angular/router';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';

@Component({
  selector: 'app-message-thread',
  templateUrl: './message-thread.component.html',
  styleUrls: ['./message-thread.component.scss']
})
export class MessageThreadComponent implements OnInit, OnChanges {

  @Input() itemFullView: any;
  @Input() messageThreadId: any;
  @Input() messageDetail: any;
  @Input() sendToParent: boolean;
  @Input() isParent: boolean;
  threadData = [];
  messageTopic;
  currentIframeSelectedAttachment;
  currentIframeSelectedFileName;
  showPopUpView = false;
  completeUrl;
  showThreadLoader;
  userData;
  username: string;
  messageData: any = {};
  dataLoaded = false;
  userRole: string;
  userModule: string;
  localStudentId: number;
  pageUrl: string;
  constructor(
    private notificationService: NotificationService,
    @Inject(APP_CONFIG) private _config: IAppConfig,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private draggableModalService: DraggableModalService,
    private _commonService: CommonService,
    protected _router: Router,
    protected _routes: ActivatedRoute
  ) { }

  ngOnInit() {
    this.userData = this._commonAuthService.getLoginData();
    this.username = `${this.userData.firstName} ${this.userData.lastName}`;
    this.userRole = this._commonAuthService.getRoleName();
    this.userModule = this._commonAuthService.getModule();
    this.pageUrl = window.location.href.split('/')[5];
    if (this.itemFullView) {
      this.showPopUpView = false;
      this.getMessageThread(this.messageThreadId);
    }
  }

  ngOnChanges() {
    if (this.itemFullView) {
      this.showPopUpView = false;
    }
  }

  gotoStudent(role, profileId, partnerId, createdUserId) {
    this.messageData['partnerId'] = partnerId;
    this.messageData['profileId'] = profileId;
    this.messageData['studentUserId'] = createdUserId;
    this.messageData['userid'] = createdUserId;

    //Restrict redirect for Essay Editors
    if (this.userModule.toLowerCase() === 'coach' && this.userRole !== 'Essay Editor' && this.pageUrl !== 'essays') {

      // redirect to CSD 
      if (role && role.toLowerCase() === 'student') {
        this._router.navigate(['../coachStudentDetail'], { relativeTo: this._routes });
        this._commonService.setDataWithoutObservable(this.messageData, 'recentStudentDetail');
      }

      // redirect to Coach Parent Page

      if (role && role.toLowerCase() === 'parent') {
        this._router.navigate(['../ParentHome'], { relativeTo: this._routes });
        this._commonService.setDataWithoutObservable(this.messageData, 'selectedParentDataFromCoach');
      }

    }


  }

  getMessageThread(threadId) {
    const parentId = localStorage.getItem('selectedStudentParentId');
    const roleName = this._commonAuthService.getRoleName();
    const isParentLogin = roleName && roleName.toLowerCase() === 'parent';
    const pageJson = {
      threadId: threadId,
      userId: (this._routes.snapshot.url[0].path === 'coachStudentDetail') ? localStorage.getItem('studentLocalId') : (this._routes.snapshot.url[0].path === 'studentSummary') && (!this.sendToParent) ? localStorage.getItem('parentStudentId') : (this._routes.snapshot.url[0].path === 'studentSummary') && (this.sendToParent) && (roleName !== 'Parent') ? parentId : this.userData.userId,
      isParent: isParentLogin ? !this.isParent : this.isParent,
    };

    this._commonRequestResponseService.postWithHeader('shared/messageThread', pageJson)
      .subscribe(
        (threadData: any) => {
          if (threadData && threadData.items) {
            this.threadData = threadData.items || [];
            this.threadData.forEach((message: any) => {
              this._commonService.formatDate(message);
              message.lastMessage = message.lastMessage.replace(/\r?\n/g, '<br />');
              if (message.from === this.username && message.createdByUserID === this.userData.userId) {
                message.mine = true;
              }
              if (message.attachmentsItem && message.attachmentsItem.length) {
                message.attachmentsItem.forEach((attachment: any, i: number) => {
                  attachment.extension = attachment.fileName.split('.').pop().split(' ')[0];
                  attachment.id = `${message.threadId}-${i}`;
                })
              }
            });
            this.messageTopic = this.threadData[this.threadData.length - 1]['subject'];
          }
          this.dataLoaded = true;
          this.showThreadLoader = false;
        },
        () => {
          this.notificationService.show('error', 'Error while getting thread data');
          this.showThreadLoader = false;
        });
  }

  getSelectedAttachment(fileName, selectedAttachment, attachment?: any) {
    this.currentIframeSelectedFileName = fileName;
    this.currentIframeSelectedAttachment = selectedAttachment;
    const baseId = 'modal-attachment-preview';
    const id = `${baseId}-${attachment ? attachment.id : Date.now()}`;
    const header = `Attachment preview (${fileName})`;
    this.draggableModalService.show({
      id,
      baseId,
      trayTitle: header,
      width: 1000,
      height: 500,
      initialState: {
        header,
        fileName: this.currentIframeSelectedFileName,
        fileUrl: this.currentIframeSelectedAttachment
      }
    });
  }
}
